import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { amplitudeModule } from '@/modules/amplitude';
import {
  OnboardingOptionItem,
  OnboardingOptionsList,
} from '@/pages/Onboarding/components/List';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

import { ContentContainer, PageStyles } from './LonelyNights.styles.ts';

const LonelyNightsOptions: {
  id: NonNullable<LayoutDataType['lonely_nights']>;
  title: string;
}[] = [
  {
    id: 'no',
    title: 'No',
  },
  {
    id: 'yes',
    title: 'Yes',
  },
];

export const LonelyNights: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'LonelyNights',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const lonelyNights = form.watch('lonely_nights');

  const handleChange = () => {
    nextStepTimeout(wizard.nextStep);
  };

  return (
    <PageStyles>
      <IonContent>
        <OnboardingNavigation />
        <ContentContainer>
          <OwnAiTitle className={'title'}>No one around… just you?</OwnAiTitle>
          <OnboardingOptionsList direction={'row'}>
            {LonelyNightsOptions.map((option) => (
              <OnboardingOptionItem
                checked={lonelyNights === option.id}
                control={form.control}
                option={option}
                name="lonely_nights"
                key={option.id}
                onChange={() => handleChange()}
                TEST_ID={`lonely_nights-${option.id}`}
                expand={true}
              />
            ))}
          </OnboardingOptionsList>
        </ContentContainer>
      </IonContent>
    </PageStyles>
  );
};
